"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerFeesQuery = exports.PricingFeeMutate = exports.PricingFeeFull = exports.PricingFee = exports.PricingFeeTypeLabels = exports.PricingFeeType = exports.PricingFeeTypes = exports.PricingFeeHowToApplyLabels = exports.PricingFeeHowToApply = exports.PricingFeeHowToApplies = exports.PricingFeeWhereToApplyLabels = exports.PricingFeeWhereToApply = exports.PricingFeeWhereToApplies = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const payment_method_1 = require("../common/payment-method");
exports.PricingFeeWhereToApplies = ['ALWAYS', 'FIRST_ORDER', 'MANUAL'];
exports.PricingFeeWhereToApply = typebox_1.Type.Union(exports.PricingFeeWhereToApplies.map((type) => typebox_1.Type.Literal(type)));
exports.PricingFeeWhereToApplyLabels = {
    ALWAYS: 'Always',
    FIRST_ORDER: 'First Order Only',
    MANUAL: 'Manual',
};
exports.PricingFeeHowToApplies = ['LINE_ITEM', 'HAUL', 'DUMP', 'OVER', 'SUBTOTAL', 'TOTAL'];
exports.PricingFeeHowToApply = typebox_1.Type.Union(exports.PricingFeeHowToApplies.map((type) => typebox_1.Type.Literal(type)));
exports.PricingFeeHowToApplyLabels = {
    LINE_ITEM: 'Line Item',
    HAUL: 'Haul',
    DUMP: 'Dump',
    OVER: 'Overage',
    SUBTOTAL: 'Subtotal',
    TOTAL: 'Total',
};
exports.PricingFeeTypes = ['FIXED', 'PERCENT', 'PAYMENT_FEE'];
exports.PricingFeeType = typebox_1.Type.Union(exports.PricingFeeTypes.map((type) => typebox_1.Type.Literal(type)));
exports.PricingFeeTypeLabels = {
    FIXED: 'Fixed',
    PERCENT: 'Percent',
    PAYMENT_FEE: 'Payment Fee',
};
exports.PricingFee = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    taxable: typebox_1.Type.Boolean(),
    whereToApply: exports.PricingFeeWhereToApply,
    howToApply: exports.PricingFeeHowToApply,
    forPaymentMethod: typebox_1.Type.Optional(payment_method_1.PaymentMethod), // if null, applies to all payment methods
    type: exports.PricingFeeType,
    amount: typebox_1.Type.Integer(),
    paymentFeeFixedAmount: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    effectiveDate: typebox_1.Type.String(),
    expirationDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
});
exports.PricingFeeFull = typebox_1.Type.Intersect([
    exports.PricingFee,
    typebox_1.Type.Object({
        zones: typebox_1.Type.Array(typebox_1.Type.Object({
            id: typebox_1.Type.String({ format: 'uuid' }),
            zoneName: typebox_1.Type.String(),
        })),
    }),
]);
exports.PricingFeeMutate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.PricingFee, ['id', 'haulerID', 'metadata']),
    typebox_1.Type.Object({
        attachToZones: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }))),
    }),
]);
exports.HaulerFeesQuery = typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Partial(typebox_1.Type.Object({
        includeExpired: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
        type: typebox_1.Type.Optional(exports.PricingFeeType),
    })),
]);
//# sourceMappingURL=fee.js.map